import "./NextVideoCard.scss";
import { Link } from "react-router-dom";
function NextVideoCard({ id, img, title, channel }) {
  return (
    <Link to={`/video/${id}`} className="card">
      <img className="card__img" src={img} alt={title} />
      <div className="card__text">
        <h3>{title}</h3>
        <p>{channel}</p>
      </div>
    </Link>
  );
}

export default NextVideoCard;
